import { render, staticRenderFns } from "./IntegralMall.vue?vue&type=template&id=0aa77aba&scoped=true"
import script from "./IntegralMall.vue?vue&type=script&lang=js"
export * from "./IntegralMall.vue?vue&type=script&lang=js"
import style0 from "./IntegralMall.vue?vue&type=style&index=0&id=0aa77aba&prod&lang=scss&scoped=true"
import style1 from "./IntegralMall.vue?vue&type=style&index=1&id=0aa77aba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa77aba",
  null
  
)

export default component.exports